import { useQuery } from "@tanstack/react-query";
import { api } from "../../../api";
import { OrgCategory } from "../../../generated/core-api";

/**
 * Hook for listing organization roles (members)
 */
export function useListOrgRolesByOrg(category?: OrgCategory, orgId?: string) {
  return useQuery({
    queryKey: ["orgs", category, orgId, "members"],
    queryFn: () =>
      api.listOrgRolesByOrg(category as OrgCategory, orgId as string),
    enabled: !!category && !!orgId,
  });
}
